import { render, staticRenderFns } from "./table1-dialog.vue?vue&type=template&id=7c87cdc0&scoped=true"
import script from "./table1-dialog.vue?vue&type=script&lang=js"
export * from "./table1-dialog.vue?vue&type=script&lang=js"
import style0 from "./table1-dialog.vue?vue&type=style&index=0&id=7c87cdc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87cdc0",
  null
  
)

export default component.exports